import { styled, selectTheme } from '@creditas-ui/react';

const FloatingContainer = styled.div`
  min-width: 116px;
  flex-direction: column;
  position: absolute;
  right: 0;
  z-index: ${selectTheme('elevation.xs')};
  padding-top: ${selectTheme('spacingTop.2xl')};
`;

const OptionList = styled.div`
  overflow-y: auto;
  box-shadow: 0px 10px 12px rgb(0 0 0 / 8%), 0px 12px 12px rgb(0 0 0 / 1%);
  border-radius: ${selectTheme('dropdown.options.borderRadius')};
  background: ${selectTheme('dropdown.options.backgroundColor')};
`;

export { FloatingContainer, OptionList };
